﻿import { useState, useCallback, useEffect } from "react";
import { AssessmentFlow } from "./components/AssessmentFlow";
import { NavBar } from "./components/NavBar";
import { Methodology } from "./components/Methodology";

type Page = "home" | "methodology";

function App() {
  const [page, setPage] = useState<Page>("home");
  const [flowKey, setFlowKey] = useState(0);
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    fetch("/api/health")
      .then((r) => setOffline(!r.ok))
      .catch(() => setOffline(true));
  }, []);

  const navigateHome = useCallback(() => {
    sessionStorage.removeItem("careerai_assessment");
    setPage("home");
    setFlowKey((k) => k + 1);
  }, []);

  const navigateMethodology = useCallback(() => {
    setPage("methodology");
  }, []);

  return (
    <div className="min-h-screen bg-[#0f172a]">
      <NavBar
        onNavigateHome={navigateHome}
        onNavigateMethodology={navigateMethodology}
      />
      {offline && (
        <div className="fixed top-12 left-0 right-0 z-40 bg-[#f97316]/90 backdrop-blur-sm text-white text-xs text-center py-1.5">
          离线模式：无法连接服务器，请确认后端已启动（
          <button
            onClick={() => setOffline(false)}
            className="underline hover:text-white/80"
          >
            关闭
          </button>
          ）
        </div>
      )}
      {page === "methodology" ? (
        <Methodology onBack={navigateHome} />
      ) : (
        <AssessmentFlow key={flowKey} />
      )}
    </div>
  );
}

export default App;